import { useState } from 'react';
import { ButtonSecondary } from '@ui/src';
import { CustomerStatus } from '../../../hoc/customers/types';
import DocumentComment from './document-comment';
import { DocumentInfoCommentsTypes } from './types';

import cn from './documents.module.css';

const DocumentInfoComments = ({
  comments,
  sendComment,
  commentInProgress,
  documentId,
  textareaRef,
  commentsVisible,
  status,
}: DocumentInfoCommentsTypes) => {
  const [value, setValue] = useState('');
  const [rows, setRows] = useState(5);
  const [count, setCount] = useState(1);

  const onKeyUp = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      setCount(count + 1);

      if (count > 4) {
        setRows(rows + 1);
      }
    }

    if (rows > 5 && e.key === 'Backspace') {
      const lines = e.currentTarget.textContent.replace(/\s/g, '/').split('/');

      if (rows > lines.length) {
        setRows(lines.length);
        setCount(lines.length);
      }
    }
  };

  const onSubmit = () => {
    sendComment(value);
    setValue('');
  };

  let commentsContent;

  if (!comments?.length) {
    commentsContent = <div className={cn.emptyComments}>No Comments</div>;
  } else {
    commentsContent = (
      <>
        {comments.map((item) => (
          <DocumentComment
            key={item.id}
            comment={item}
            documentId={documentId}
            commentsVisible={commentsVisible}
          />
        ))}
      </>
    );
  }

  return (
    <div className={cn.documentInfoCommentsWrapper}>
      {status !== CustomerStatus.CLOSED && (
        <div className={cn.documentInfoCommentsTitle}>Add a comment</div>
      )}
      {commentsVisible && status !== CustomerStatus.CLOSED && (
        <>
          <textarea
            rows={rows}
            className={cn.documentInfoComment}
            placeholder="Enter a comment..."
            value={value}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
              setValue(e.target.value)
            }
            onKeyUp={(e) => onKeyUp(e)}
            ref={textareaRef}
          />
          <ButtonSecondary
            text={commentInProgress ? 'Loading...' : 'Post'}
            className={`${cn.postCommentButton} ${
              !value.length ? 'button-white' : ''
            }`}
            disabled={Boolean(!value.length) || commentInProgress}
            onClick={onSubmit}
          />
        </>
      )}

      <div className={cn.commentsList}>{commentsContent}</div>
    </div>
  );
};

export default DocumentInfoComments;
